import React from "react";
import { Home } from "lucide-react";

/**
 * Displays "40% reserved for local citizens" with a progress bar.
 * Uses project.local_reservation_pct + optional units_total + local_units_reserved.
 */
export default function LocalReservationBadge({ project, compact = false }) {
  const pct = Math.min(100, Math.max(0, Number(project?.local_reservation_pct ?? 40)));
  const total = Number(project?.units_total ?? 0);
  const reserved = Math.round(total * pct / 100);
  return (
    <div
      className={`inline-flex flex-col rounded-2xl ${compact ? "px-2.5 py-1.5" : "px-3 py-2"}`}
      style={{ background: "rgba(212,175,55,0.14)" }}
      data-testid="local-reservation-badge"
    >
      <div className="flex items-center gap-1.5">
        <Home size={compact ? 12 : 13} className="mv-green-text"/>
        <span className={`font-semibold mv-green-text ${compact ? "text-[10.5px]" : "text-[11.5px]"} uppercase tracking-[0.14em]`}>
          {pct}% local reserved
        </span>
      </div>
      {total > 0 && !compact && (
        <div className="text-[11px] mt-0.5" style={{ color: "var(--mv-muted)" }}>
          {reserved} of {total} units for citizens in-country
        </div>
      )}
    </div>
  );
}
